import { useEffect, useState } from "react";

// React DOM
import { useParams, useNavigate } from "react-router-dom";

// Icons and Backgrounds
import SocialMedia from "../../components/SocialMedia";

// Axios
import Axios from "../../api/axios";

// CSS Styling
import "../../styles/detailBlog.css";

// HTML react parser
import parse from "html-react-parser";

// Sweet Alert v2
import Swal from "sweetalert2";

// react responsive
import { useMediaQuery } from "react-responsive";

// Components
import ContainerText from "../../components/Container";
import Header from "../../components/Header";
import Footer from "../../components/Footer";

// API
import { getNewsById } from "../../api/getNewsById";

// React lottie
import Lottie from "react-lotties";
import PaperPlane from "../../lotties/paperplane.json";

// Lucide React
import { CircleUserRound } from "lucide-react";

const DetailBlog = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  const isMobileSize = useMediaQuery({ query: "(max-width: 640px)" });

  const [news, setNews] = useState([]);
  const [relatedNews, setRelatedNews] = useState([]);
  const [isLoading, setLoading] = useState(false);

  const [activeLanguage, setActiveLanguage] = useState("en");

  // React lotties
  const lottieOptions = {
    loop: true,
    autoplay: true,
    animationData: PaperPlane,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  function refreshNews(id) {
    navigate(`/Blog/${id}`);
    window.location.href = "#detailBlog";
    window.location.reload(false);
  }

  const HTMLparse = (string) => {
    return parse(string);
  };

  const copyLink = () => {
    navigator.clipboard.writeText(
      `https://www.sustainability.co.id/Blog/${id}`
    );
    Swal.fire({
      position: "center",
      imageUrl:
        "https://cdn.discordapp.com/attachments/796711355876245534/986824551537209404/copy_clipboard_icon.png",
      imageWidth: 200,
      imageHeight: 200,
      width: "45em",
      title: "Success",
      text: "Link has been copied to clipboard",
      showCloseButton: true,
      showConfirmButton: false,
      timer: 1500,
      background: "#E4E4E4",
    });
  };

  const fetchRelatedNews = async () => {
    const response = await Axios.get(`/news/relatedNews`).catch((err) => {
      console.log("Err: ", err);
    });
    setRelatedNews(response.data);
  };

  useEffect(() => {
    const fetchNewsById = async () => {
      setLoading(true);
      try {
        const response = await getNewsById(id);
        if (response.data.status === "Published") {
          setNews(response.data);
          HTMLparse(response.data.htmlContent);
          fetchRelatedNews();
        } else {
          Swal.fire(`Oops`, `Data not found`, `error`).then(() =>
            navigate("/Blog")
          );
        }
      } catch (err) {
        console.log(err);
      } finally {
        setLoading(false);
      }
    };
    fetchNewsById();
  }, [id]);

  return (
    <div id="detailBlog">
      <Header />
      {!isLoading ? (
        <ContainerText
          props={
            <div className="detailBlogContainer">
              <div className="d-flex align-items-center justify-content-between mb-4 mb-md-5">
                <div
                  className="previousButton"
                  onClick={() => navigate("/Blog")}
                >
                  <span className="expertiseArrowRight">
                    <i className="fas fa-angle-left" />
                  </span>
                  <a href="">Back to previous page</a>
                </div>

                {news.title_idn && news.title_en ? (
                  <div className="d-flex align-items-center gap-2">
                    <label className="form-check-label d-inline-flex align-items-center cursor-pointer me-3 me-sm-4">
                      <span className="fw-bold text-dark px-5 title">EN</span>

                      <div
                        onClick={() =>
                          setActiveLanguage(
                            activeLanguage === "en" ? "id" : "en"
                          )
                        }
                        className="form-check form-switch m-0 p-0"
                      >
                        <input
                          className="form-check-input"
                          type="checkbox"
                          role="switch"
                          id="langSwitch"
                          checked={activeLanguage === "id"}
                          onChange={() =>
                            setActiveLanguage(
                              activeLanguage === "en" ? "id" : "en"
                            )
                          }
                          style={{
                            width: "3.5rem",
                            height: "2rem",
                            cursor: "pointer",
                            backgroundColor: "#E78D41",
                          }}
                        />
                      </div>

                      <span className="ms-2 fw-bold text-dark title">ID</span>
                    </label>
                  </div>
                ) : news.title_idn && !news.title_en ? (
                  <div>
                    <p className="fw-medium mb-0 text-dark paragraf">
                      Artikel berikut hanya tersedia dalam Bahasa Indonesia
                    </p>
                  </div>
                ) : !news.title_idn && news.title_en ? (
                  <div>
                    <p className="fw-medium mb-0 text-dark paragraf">
                      This article is only available in English
                    </p>
                  </div>
                ) : null}
              </div>
              <div className="detailBlogMainTitle headerDescription">
                <p>
                  {news.title_en && activeLanguage === "en"
                    ? news.title_en
                    : news.title_idn && activeLanguage === "id"
                    ? news.title_idn
                    : news.title_en || news.title_idn}
                </p>
              </div>
              <div className="paragrafDesc">
                <p>
                  <i>
                    {news.date} – {news.contentType}
                  </i>
                </p>
                <div className="d-flex align-items-center gap-2 gap-sm-3">
                  <div
                    className="rounded-circle overflow-hidden flex-shrink-0"
                    style={{
                      width: "40px",
                      height: "40px",
                    }}
                  >
                    {news.written_by_img ? (
                      <img
                        src={news?.written_by_img}
                        alt={`${news?.written_by}`}
                        className="w-100 h-100 object-fit-cover rounded-circle img-fluid"
                      />
                    ) : (
                      <CircleUserRound size={40} />
                    )}
                  </div>

                  <div>
                    <p className="fw-medium mb-0 text-dark paragrafDesc">
                      Written by <b>{news?.written_by}</b>
                    </p>
                  </div>
                </div>
              </div>
              <div className="detailBlogSocialMedia right">
                <SocialMedia
                  twitterURL={`https://www.sustainability.co.id/Blog/${id}`}
                  facebookURL={`https://www.sustainability.co.id/Blog/${id}`}
                  linkedinURL={`https://www.sustainability.co.id/Blog/${id}`}
                  mailSubject={
                    activeLanguage === "id" ? news.title_idn : news.title_en
                  }
                  mailContent={`Hello, I recommend you to read the articles on Institute for Sustainability and Agility (ISA): ${
                    activeLanguage === "id" ? news.title_idn : news.title_en
                  } https://www.sustainability.co.id/Blog/${id}`}
                  copyLink={copyLink}
                />
              </div>
              <div className="detailBlogHtmlContent">
                <div
                  style={{
                    display: "flex",
                    flexDirection: isMobileSize ? "column" : "row",
                    justifyContent: "space-between",
                  }}
                >
                  {/* <div style={{ paddingRight: "3em" }}>
                    <img
                      src={news.content_image}
                      alt="Content Image"
                      style={{ width: "300 px", height: "300 px" }}
                    ></img>
                  </div> */}
                  <div style={{ marginTop: isMobileSize ? "0.5em" : "-0.5em" }}>
                    {HTMLparse(`${news.htmlContent}`)}
                  </div>
                </div>
              </div>
              <div className="detailBlogSocialMedia left">
                <SocialMedia
                  twitterURL={`https://www.sustainability.co.id/Blog/${id}`}
                  facebookURL={`https://www.sustainability.co.id/Blog/${id}`}
                  linkedinURL={`https://www.sustainability.co.id/Blog/${id}`}
                  mailSubject={
                    activeLanguage === "id" ? news.title_idn : news.title_en
                  }
                  mailContent={`Hello, I recommend you to read the articles on Institute for Sustainability and Agility (ISA): ${
                    activeLanguage === "id" ? news.title_idn : news.title_en
                  } https://isa-stg.cloudxier.com/Blog/${id}`}
                  copyLink={copyLink}
                />
              </div>
            </div>
          }
        />
      ) : (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            textAlign: "center",
            paddingTop: "15em",
          }}
        >
          <Lottie options={lottieOptions} height={200} width={400} />
          <h4
            style={{
              color: "#0D4C86",
            }}
          >
            LOADING
          </h4>
          <p
            style={{
              color: "#0D4C86",
            }}
          >
            Processing your request, please wait...
          </p>
        </div>
      )}
      {relatedNews.length > 0 ? (
        <div className="detailUpdates">
          <ContainerText
            props={
              <div className="detailUpdatesContainer">
                <div className="detailUpdatesMainTitle header">
                  <p>Related Updates</p>
                </div>
                <div className="detailUpdatesCardContainer">
                  {relatedNews.map((element) => {
                    return element.status === "Published" ? (
                      <div className="detailUpdatesCardEach" key={element.id}>
                        <div className="detailUpdatesCardImage">
                          <img src={element.picture} alt="Card blog" />
                        </div>
                        <div className="detailUpdatesCardTitle title">
                          <p onClick={() => refreshNews(element.id)}>
                            {element.title}
                          </p>
                        </div>
                        <div className="detailUpdatesCardDate paragrafDesc">
                          <p>
                            <i>
                              {element.date} – {element.contentType}
                            </i>
                          </p>
                        </div>
                        <div className="detailUpdatesCardSubTitle paragraf">
                          <p>{element.description}</p>
                        </div>
                      </div>
                    ) : null;
                  })}
                </div>
              </div>
            }
          />
        </div>
      ) : null}
      <Footer />
    </div>
  );
};

export default DetailBlog;
